import { useEffect, useState } from 'react';

interface PreloaderProps {
    onLoadingComplete?: () => void;
}

export default function Preloader({ onLoadingComplete }: PreloaderProps) {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const done = () => {
            setVisible(false);
            onLoadingComplete?.();
        };

        if (document.readyState === 'complete') {
            done();
            return;
        }

        window.addEventListener('load', done);
        return () => window.removeEventListener('load', done);
    }, [onLoadingComplete]);

    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-9999 flex items-center justify-center bg-white text-typo">
            <span className="animate-pulse text-lg font-medium">Loading...</span>
        </div>
    );
}
